import getCookie from '@/helpers/getCookie';

export default function() { return getCookie('csrftoken'); }
